import { render, staticRenderFns } from "./SensorBulkUploadScreen.vue?vue&type=template&id=0c3a852c&scoped=true&lang=pug"
import script from "./SensorBulkUploadScreen.vue?vue&type=script&lang=ts"
export * from "./SensorBulkUploadScreen.vue?vue&type=script&lang=ts"
import style0 from "./SensorBulkUploadScreen.vue?vue&type=style&index=0&id=0c3a852c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3a852c",
  null
  
)

export default component.exports